import styled, { css } from 'styled-components';
import { Typography } from '../ui/Typography';
import { Breakpoints } from '../../styled/constants';

export const WhiteHeaderContainer = styled.div<{
  $isMain?: boolean;
  $isFixed?: boolean;
  $isCenter?: boolean;
  $noBorder?: boolean;
}>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  padding: 0 15px;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.border.primary};

  ${({ $noBorder }) =>
    $noBorder &&
    css`
      border-bottom: 0;
    `}

  ${({ $isCenter }) =>
    $isCenter &&
    css`
      position: relative;
      justify-content: center;
    `}

  ${({ $isMain }) =>
    $isMain &&
    css`
      justify-content: space-between;
      border-bottom: 0;
      padding: 15px;
      align-items: center;

      @media screen and (min-width: ${Breakpoints.tablet}px) {
        height: 74px;
        padding: 15px 40px;
      }
    `}

  ${({ $isFixed, theme }) =>
    $isFixed &&
    css`
      position: sticky;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 95;
      background: ${theme.colors.background.primary};

      .scrolling & {
        border-bottom: 0.5px solid ${theme.colors.border.primary};
      }
    `}
`;

export const WhiteHeaderTitle = styled(Typography)`
  text-align: center;
  margin: 0;
`;

export const WhiteHeaderWebviewBtn = styled.button`
  position: absolute;
  right: 0;
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 8px;
  padding: 0;

  i {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  svg {
    display: block;
    flex: 1;
  }
`;
